import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AssessmentProvider } from './context/AssessmentContext';
import { UserProvider } from './context/UserContext';
import AssessmentFlow from './components/AssessmentFlow';
import DashboardPage from './pages/DashboardPage';
import ProfilePage from './pages/ProfilePage';
import QuestsPage from './pages/QuestsPage';
import OnboardingPage from './pages/OnboardingPage';
import Layout from './components/common/Layout';
import Navigation from './components/common/Navigation';
import ProtectedRoute from './components/common/ProtectedRoute';
export function App() {
  return <BrowserRouter data-id="element-0">
      <UserProvider data-id="element-1">
        <AssessmentProvider data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/assessment" element={<AssessmentFlow data-id="element-5" />} data-id="element-4" />
            <Route path="/onboarding" element={<OnboardingPage onComplete={() => {}} data-id="element-7" />} data-id="element-6" />
            <Route path="/" element={<ProtectedRoute data-id="element-9">
                  <Layout data-id="element-10">
                    <Navigation data-id="element-11" />
                    <Routes data-id="element-12">
                      <Route path="/dashboard" element={<DashboardPage data-id="element-14" />} data-id="element-13" />
                      <Route path="/quests" element={<QuestsPage data-id="element-16" />} data-id="element-15" />
                      <Route path="/profile" element={<ProfilePage data-id="element-18" />} data-id="element-17" />
                      <Route path="/" element={<Navigate to="/dashboard" replace data-id="element-20" />} data-id="element-19" />
                    </Routes>
                  </Layout>
                </ProtectedRoute>} data-id="element-8" />
          </Routes>
        </AssessmentProvider>
      </UserProvider>
    </BrowserRouter>;
}